import React from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../../analyticsUtils';
import './ProfileSuggestions.scss';
var redirectToProfile = function redirectToProfile(userPath, location) {
  analyticsTrack('Clicked on Profile Suggestion Card button', {
    location: location
  });
  window.location.href = userPath;
};
function ProfileSuggestions(_ref) {
  var userPath = _ref.userPath,
    location = _ref.location,
    tagCategory = _ref.tagCategory,
    tags = _ref.tags,
    small = _ref.small;
  if (small) {
    return /*#__PURE__*/React.createElement("div", {
      className: "profile-suggestion-reminder-small body-text-3 demibold"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-2"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-magic wand"
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cta-text"
    }, "Review your Profile Suggestions"), /*#__PURE__*/React.createElement("div", {
      className: "cta-subtext normal-weight"
    }, "Add listed suggestions to improve your profile"))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "profile-suggestion-reminder-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cta row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cta-text mb-8"
  }, "Review your profile suggestions!")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-magic wand"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "body-text-2"
  }, "Clora listed profile recommendations to improve your profile."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: "profile-suggestions body-text-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, tagCategory), /*#__PURE__*/React.createElement("div", {
    className: "tags mb-2 mt-3 d-flex flex-wrap gap-2"
  }, tags.map(function (t) {
    return /*#__PURE__*/React.createElement("span", {
      key: t,
      className: "badge small normal-font"
    }, t);
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "md-4 user-profile-link"
  }, userPath && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    tabIndex: 0,
    role: "button",
    onClick: function onClick() {
      return redirectToProfile(userPath, location);
    }
  }, "View All Profile Suggestions", ' '), /*#__PURE__*/React.createElement("i", {
    className: "fas fa-angle-right"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "md-4"
  }))));
}
ProfileSuggestions.propTypes = {
  userPath: PropTypes.string,
  location: PropTypes.string,
  tagCategory: PropTypes.string,
  tags: PropTypes.bool.isRequired,
  small: PropTypes.bool
};
ProfileSuggestions.defaultProps = {
  userPath: null,
  location: '',
  small: false,
  tagCategory: ''
};
export default ProfileSuggestions;